import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Input,
  Container,
  Button,
  Segment,
  Table,
  Grid,
  Loader,
  Icon,
  Dropdown
} from 'semantic-ui-react'


import titleCase from 'title-case'
import './Students.css'

import PaginationTable from '../../components/PaginationTable/PaginationTable'
import StudentsReadCSV from './StudentsReadCSV'
import StudentsAdd from './StudentsAdd'
import StudentsEdit from './StudentsEdit'
import StudentsDelete from './StudentsDelete'
import StudentsExport from './StudentsExport'
import constants from '../../constants';

const changeCase = {
    titleCase: titleCase
}

const optionsGradeLevel = constants.breakdownGradeLevel;

const StudentsPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' || props.userType === 'staff' || props.userType === 'cashier') {
      const { activePage, itemPerPage, column, direction, data, searchKey, fields, loaded, gradeLevel } = props;
      let currentData = data.filter(props.isSearched(searchKey));
      if (gradeLevel !== '') {
        currentData = currentData.filter(data => data.gradeLevel === gradeLevel);
      }
      const indexOfLast = activePage * itemPerPage;
      const indexOfFirst = indexOfLast - itemPerPage;
      const rowLength = currentData.length;
      currentData = currentData.slice(indexOfFirst, indexOfLast);
      const totalPages = Math.ceil(rowLength / itemPerPage);
      console.log(currentData)
      const studentTable = currentData.map((student, key )=> {
        return (
          <Table.Row key={key} className='students-table-row'>
            <Table.Cell>{student.lastName}</Table.Cell>
            <Table.Cell>{student.firstName}</Table.Cell>
            <Table.Cell>{student.studentNumber}</Table.Cell>
            <Table.Cell collapsing>
              <Button icon size='tiny' onClick={() => props.handleRowClick(student)}>
                <Icon name='eye' />
              </Button>
              <StudentsEdit
                student={student}
                handleUpdate={props.handleUpdate}
              />

              <StudentsDelete
                studentId={student.studentId}
                studentName={`${student.firstName} ${student.lastName}`}
                handleDelete={props.handleDelete}
              />
            </Table.Cell>
          </Table.Row>
        );
      });

      let headers = fields.map((field,index) => {
        return (
          <Table.HeaderCell
            key={index}
            sorted={column === field ? direction : null}
            onClick={() => props.handleSort(field)}
            textAlign='center'
          >
            {changeCase.titleCase(field)}
          </Table.HeaderCell>
        )
      });

      let optionsSchoolYears;
      if (props.schoolYears) {
        optionsSchoolYears = props.schoolYears.map((schoolYear,index) => {
          return (
              { key: schoolYear.schoolYearId, value: schoolYear.schoolYearId, text: schoolYear.name }
          )
        })
      }

      return (
        <div>
          <Container>
            <Segment>
              <Grid centered>
                <Grid.Row>
                  <Dropdown
                    selection
                    name='schoolYearId'
                    options={optionsSchoolYears}
                    onChange={props.handleChangeSchoolYear}
                    value={props.schoolYearId}
                  />
                </Grid.Row>
              </Grid>
              <Grid>
                <Grid.Column floated='left' width={5}>
                  <Grid.Column width={4}>
                    <Input
                      icon='search'
                      value={searchKey}
                      onChange={props.onSearchChange}
                      placeholder='Search Students'
                    />
                  </Grid.Column>
                </Grid.Column>
                <Grid.Column floated='right' width={3}>

                  <Dropdown
                    selection
                    search
                    clearable
                    placeholder='Grade Level'
                    options={optionsGradeLevel}
                    onChange={props.handleChange}
                    name='gradeLevel'
                    value={props.gradeLevel}
                  />

                </Grid.Column>
                <Grid.Column width={3}>
                  {
                    currentData.length > 0 ?
                    <StudentsExport data={currentData} gradeLevel={gradeLevel}/> :
                    null
                  }
                </Grid.Column>

                <Grid.Column floated='right' width={5}>
                  <Grid.Column floated='right' width={8}>
                  <Button.Group floated='right'>
                    <StudentsReadCSV
                      modalImportOpen={props.modalImportOpen}
                      setOpen={props.handleModalImportOpen}
                      handleFileChange={props.handleFileChange}
                      handleDataSave={props.handleDataSave}
                    />
                    <Button.Or />
                    <StudentsAdd
                      handleSubmit={props.handleSubmit}
                    />
                  </Button.Group>

                </Grid.Column>

                </Grid.Column>
              </Grid>
              {
                loaded ?
                <div className='table-students'>
                  {
                    data.length > 0 ?
                    <Table celled selectable sortable striped size='small'>
                      <Table.Header>
                        <Table.Row>
                          {headers}
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>{studentTable}</Table.Body>
                        {
                          data.length > itemPerPage ?
                          <PaginationTable
                            onPageChange={props.handlePaginationChange}
                            totalPages={totalPages}
                            activePage={activePage}
                            fields={fields}
                          >
                            {props.children}
                          </PaginationTable>
                          :
                          null
                        }
                    </Table>
                    :
                    <Segment>No student records found.</Segment>
                  }
                </div>

                :
                <Loader active inline='centered' />
              }

            </Segment>
          </Container>
        </div>
      )
    } else {
      return <Segment>You are not authorized to be in this page.</Segment>
    }

  } else {
    return <Redirect to='/' />
  }

}

export default StudentsPV;
